import React from "react";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import QuestionMarkIcon from "../assets/icons/icon-material-live-help.svg";
import ArrowRightIco from "../assets/icons/arrow-right-ico.svg";
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';
import { Link } from "react-router-dom/cjs/react-router-dom.min";


const Help = () => {
  return (
    <>
    <DynamicScrollToTop/>
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-8">
                <Link to="/homepage">
                <p className="flex items-center text-font-gray opacity-50">
                  Beranda{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                </Link>
                <h1 className="text-font-gray">Bantuan</h1>
              </div>
              <div className="py-4 rounded bg-white">
                <div className="flex px-1  border-gray-300 pb-4">
                  <div className="flex items-center p-4">
                    <h4 className="text-3xl font-semibold text-font-gray mb-2">
                      Topik yang sering ditanyakan
                    </h4>
                  </div>
                </div>
                {/* Topic section */}
                <div className="flex flex-row w-full mr-6 ml-6 mb-6">
                  <div>
                    <h5 className="text-lg text-gray-600 font-semibold">
                      Bagaimana cara cek status pesanan?
                    </h5>
                    <p className="mb-8 mt-8 text-gray-600">
                      Berikut ini adalah langkah-langkah untuk melihat
                      pengiriman
                    </p>
                    <button className="text-basic-orange font-semibold text-lg ">
                      Baca selengkapnya
                    </button>
                  </div>
                  <div>
                    <h5 className="text-lg text-gray-600 font-semibold">
                      Bagaimana cara cek status pesanan?
                    </h5>
                    <p className="mb-8 mt-8 text-gray-600">
                      Berikut ini adalah langkah-langkah untuk melihat
                      pengiriman
                    </p>
                    <button className="text-basic-orange font-semibold text-lg ">
                      Baca selengkapnya
                    </button>
                  </div>
                  <div>
                    <h5 className="text-lg text-gray-600 font-semibold">
                      Bagaimana cara cek status pesanan?
                    </h5>
                    <p className="mb-8 mt-8 text-gray-600">
                      Berikut ini adalah langkah-langkah untuk melihat
                      pengiriman
                    </p>
                    <button className="text-basic-orange font-semibold text-lg ">
                      Baca selengkapnya
                    </button>
                  </div>
                </div>
                {/* End of topic section */}
                <h3 className="ml-6 mb-8 mt-16 font-hairline text-2xl">
                  Menu Bantuan
                </h3>
                {/* Help menu section */}
                <div className="flex flex-row w-full mr-6 ml-6 mb-6">
                  {/* Help start first item */}
                  <div>
                    <div class="flex">
                      <div class="flex-none text-gray-700 m-4">
                        <img alt="Question mark icon" width="32" src={QuestionMarkIcon}></img>
                      </div>
                      <div class="flex-auto text-gray-700">
                        <h5 className="ml-2 text-lg font-semibold">
                          Pengajuan komplain
                        </h5>
                        <p className="m-2">
                          Kirim komplain sesuai maslah yang dihadapilewat live
                          chat atau form bantuan
                        </p>
                      </div>
                      <div class="ml-4 mt-4 flex-auto text-gray-700">
                        <img alt="Question mark icon" src={ArrowRightIco}></img>
                      </div>
                    </div>
                  </div>
                  {/* end of help start first item */}

                  {/* Help start second item */}
                  <div>
                    <div class="flex">
                      <div class="flex-none text-gray-700 m-4">
                        <img alt="Question mark icon" width="32" src={QuestionMarkIcon}></img>
                      </div>
                      <div class="flex-auto text-gray-700">
                        <h5 className="ml-2 text-lg font-semibold">FAQ</h5>
                        <p className="m-2">
                          Punya pertanyaan tentang Agrotech? temukan
                          penjelasannya di sini
                        </p>
                      </div>
                      <div class="ml-4 mt-4 flex-auto text-gray-700">
                        <img alt="Question mark icon" src={ArrowRightIco}></img>
                      </div>
                    </div>
                  </div>
                  {/* end of help start second item */}

                  {/* Help start third item */}
                  <div>
                    <div class="flex">
                      <div class="flex-none text-gray-700 m-4">
                        <img alt="Question mark icon" width="32" src={QuestionMarkIcon}></img>
                      </div>
                      <div class="flex-auto text-gray-700">
                        <h5 className="ml-2 text-lg font-semibold">
                          Riwayat Komplain
                        </h5>
                        <p className="m-2">
                          Cek status atau lanjutan komplain yang pernah kamu
                          ajukan di dini
                        </p>
                      </div>
                      <div class="ml-4 mt-4 flex-auto text-gray-700">
                        <img alt="Question mark icon" src={ArrowRightIco}></img>
                      </div>
                    </div>
                  </div>
                  {/* end of help start third item */}
                </div>
                {/* Help menu section */}
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Help;
